module.exports = __webpack_public_path__ + "static/img/warehouse.13ea687.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/warehouse.png
// module id = 94iP
// module chunks = 1